// extracted by mini-css-extract-plugin
export default {"shadow":"effects_shadow__DyUcl","disabled":"effects_disabled__O2KXu"};